import { PropsWithChildren } from 'react';
import { RouteAccessContextProvider } from '@sib/auth';
import { useSpendbrainRoutesAccess } from '@spendbrain/hooks';

export const SpendbrainRouteAccessContextProvider = ({
  children,
}: PropsWithChildren) => {
  const { isRouteAvailable, availableRoutes } = useSpendbrainRoutesAccess();

  return (
    <RouteAccessContextProvider
      isRouteAvailable={isRouteAvailable}
      availableRoutes={availableRoutes}
      enableAccessControl
    >
      {children}
    </RouteAccessContextProvider>
  );
};

export { useRouteAccessContext as useSpendbrainRouteAccessContext } from '@sib/auth';
